import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16 3h-3v2H6V3H3v16h13V3zM9.5 8c1.379 0 2.5 1.121 2.5 2.5S10.879 13 9.5 13 7 11.879 7 10.5 8.121 8 9.5 8zM7 4V2h5v2H7zm6 12H6v-1h7v1z',
  ],
  height: 20,
  width: 20,
});
